import { Stack, Typography, styled } from "@mui/material";
import { grey } from "@mui/material/colors";

const AppFooter = styled("footer")({
  backgroundColor: grey[100],
  marginTop: "auto",
});

const Header = () => (
  <AppFooter>
    <Stack
      height="4rem"
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="caption" component="div">
        This website has been created as part of a UNSW thesis project.
      </Typography>
    </Stack>
  </AppFooter>
);

export default Header;
